import { MENU_INTERNO } from "./menu";

export const PERMISSOES_DO_CONSOLE: readonly [string, string, string][] = [
  ["radar:integracao", "Radares", "Radar da Integração"],
  ["radar:onboarding", "Radares", "Radar do Onboarding"],
  ["radar:infra", "Radares", "Radar da Infra"],
  ["radar:equipe", "Radares", "Ver a equipe"],
  ["console:ver", "Implantação", "Ver o console interno"],
  ["implantacao:visao", "Implantação", "Ver a Visão da implantação"],
  ["implantacao:criar", "Implantação", "Criar implantação"],
  ["reuniao:agendar", "Implantação", "Registrar reuniões"],
  ["ata:editar", "Implantação", "Editar atas"],
  ["ata:publicar", "Implantação", "Publicar atas"],
  ["kickoff:revisar", "Implantação", "Analisar Kick Off"],
  ["implantacao:repassar", "Implantação", "Concluir e repassar ao Atendimento"],
  ["ambiente:liberar", "Implantação", "Liberar ambiente"],
  ["infra:ver", "Infraestrutura", "Ver o cofre e infraestrutura"],
  ["credencial:revelar", "Infraestrutura", "Revelar credencial do cofre"],
  ["catalogo:gerenciar", "Catálogos", "Editar Recursos Plus"],
  ["questionario:gerenciar", "Catálogos", "Editar perguntas do kickoff"],
  ["ticket:ver", "Atendimento", "Chamados"],
  ["usuarios:gerenciar", "Contas e acessos", "Gerenciar usuários internos"],
  ["perfil:gerenciar", "Contas e acessos", "Gerenciar perfis"],
];

export const POR_CHAVE = new Map<string, { grupo: string; rotulo: string }>(
  PERMISSOES_DO_CONSOLE.map(([chave, grupo, rotulo]) => [chave, { grupo, rotulo }] as const),
);
export function rotuloDaPermissao(chave: string): string {
  return POR_CHAVE.get(chave)?.rotulo ?? chave;
}

export const GRUPOS = ["Radares", "Implantação", "Infraestrutura", "Catálogos", "Atendimento", "Contas e acessos", "Outras permissões"];

export function menuPrevisto(permissoes: ReadonlySet<string>): string[] {
  return MENU_INTERNO.filter((item) => !item.permissao || permissoes.has(item.permissao))
    .map((item) => item.rotulo);
}
